import React from 'react';
import Header from '../components/Header';
import Recyclable from '../components/Recyclable';
import Footer from '../components/Footer';

const RecyclablePage = () => {
  return (
    <div className="App">
      <Header />
      <Recyclable />
      <Footer />
    </div>
  );
};

export default RecyclablePage;
